'use client';

import { Suspense } from 'react';
import { usePathname } from 'next/navigation';
import { isMarketingRoute } from '@/lib/marketing-routes';
import { Navbar } from './Navbar';
import { AppNavbar } from './AppNavbar';
import { MobileTabBar } from './MobileTabBar';
import PopupRAGChat from './PopupRAGChat';

/**
 * 전역 크롬 게이트 — 마케팅 경로(src/lib/marketing-routes.ts 참조)에서는
 * 기존 업무 앱 크롬 4개를 렌더하지 않고, 나머지 모든 경로는 기존 동작을 유지한다.
 */
export function MarketingShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const hideChrome = isMarketingRoute(pathname);

  return (
    <>
      {!hideChrome && <Suspense fallback={null}><Navbar /></Suspense>}
      {!hideChrome && <Suspense fallback={null}><AppNavbar /></Suspense>}
      {children}
      {!hideChrome && <MobileTabBar />}
      {!hideChrome && <PopupRAGChat />}
    </>
  );
}
